/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ExtraInformationForKeyViewModel } from "./ExtraInformationForKeyViewModel";
import { ClientConfigurationDormerSpecificSettingsDto } from "./ClientConfigurationDormerSpecificSettings/ClientConfigurationDormerSpecificSettingsDto";

export class ClientInformationViewModel {
    minWidth: number;
    maxWidth: number;
    minDepth: number;
    maxDepth: number;
    clientConfigurationId: string;
    organisationId: string;
    chamberOfCommerce: string;
    name: string;
    address: string;
    countryCode: string;
    postalCode: string;
    city: string;
    contactPhoneNumber: string;
    contactEmailAddress: string;
    supportPhoneNumber: string;
    supportEmailAddress: string;
    logoUrl: string;
    primaryColor: string;
    secondaryColor: string;
    pricePerCubicMeter: number;
    basePrice: number;
    vatPercentage: number;
    extraInformation: string;
    leadPostedSuccessRedirectUrl: string;
    privacyPolicyUrl: string;
    excludeFrameFromCladdingPriceCalculation: boolean;
    extraInformationForKeys: ExtraInformationForKeyViewModel[];
    dormerSpecificSettings: ClientConfigurationDormerSpecificSettingsDto;
    colorAmountToShowByDefault: number;
}
